<template>
  <div>
    <setting></setting>
    <v-app>
      <div :class="!list ? 'col-md-10 mx-auto mt-20 pt-5' : 'mt-5 pt-5'">
        <div style="border: none">
          <span class="mr-3">تعداد شماره های قابل اضافه  :  <span>{{ reachable }}</span></span>
          <v-card-text>
            <v-alert
                v-if="alertConfirm===true"
                v-model="alertConfirm"
                class="my-5"
                dismissible
                elevation="12"
                transition="slide-y-transition"
                type="success"
            >
              کد تایید برای شما تا دقایقی دیگر ارسال میگردد.
            </v-alert>
            <v-row v-if="expired===false && (reachable > 0)">
              <v-col cols="12" sm="6">
                <v-text-field
                    v-model="number"
                    :disabled="checkCode===true"
                    :loading="loading===true"
                    :rules="numberRules"
                    class="mt-5"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    counter="10"
                    hint="شماره تماس وارد شده فقط باید شامل اعداد باشد."
                    inputmode="numeric"
                    label="شماره تماس"
                    maxLength="10"
                    name="phone"
                    pattern="[0-9]*"
                    required
                    type="number"
                    @keypress="allowOnlyNumbers($event,name,type)"
                    @keypress.enter="getConfirmCode"
                >
                </v-text-field>
              </v-col>
              <v-col v-show="checkCode===true" cols="12" sm="6">
                <v-text-field
                    ref="confirmCode"
                    v-model="confirmCode"
                    :counter="max"
                    class="mt-5"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    hint="کد تایید ارسال شده به شماره خود را وارد کنید."
                    inputmode="numeric"
                    label="کد تایید"
                    maxlength="6"
                    name="verifyCode"
                    pattern="[0-9]*"
                    required
                    type="text"
                    @keypress="allowOnlyNumbers($event,name,type)"
                    @keypress.enter="submitCode"

                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="expired===false && reachable > 0">
              <v-col v-show="checkCode===false" cols="12" sm="4">
                <v-btn
                    v-status="'divar_phone'"
                    :disabled="!number"
                    class="btn-get-code"
                    @click="getConfirmCode"
                >
                  <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                  دریافت کد تایید
                </v-btn>
              </v-col>
              <v-col v-show="checkCode===true" cols="12" sm="4">
                <v-btn
                    :disabled="!confirmCode"
                    class="submit-btn"
                    @click="submitCode"
                >
                  <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                  ثبت کد تایید
                </v-btn>
              </v-col>
              <v-col class="text-left mr-auto" cols="12" sm="6">
                <v-btn
                    color="primary"
                    text
                    @click="checkCode = false"
                >
                  <span class="material-icons">keyboard_return</span>
                  بازگشت
                </v-btn>
              </v-col>
            </v-row>
            <div v-if="expired===true">
              <v-alert
                  class="my-5"
                  color="red"
                  elevation="4"
                  outlined
                  type="error"
              >
                شما قادر به اضافه کردن شماره جدیدی نیستید.
                برای اضافه کردن شماره جدید بسته <b>افزایشی خرید</b> کنید.
              </v-alert>
            </div>
          </v-card-text>
          <v-card-text v-if="reachable <= 0">
            <div class="row mx-auto">
              <p class="font-weight-bold mx-1 text-dark"> قیمت هر لاین : <span class="font-weight-bold">{{
                  perLinePrice
                }}</span>
              </p>
              <p class="font-weight-bold text-dark mr-auto">مدت هر لاین : <span
                  class="font-weight-bold">{{ expireTime }}</span></p>
            </div>
            <v-row>
              <v-col cols="12">
                <v-text-field
                    v-model="linesCount"
                    class=""
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    counter="3"
                    hint="تعداد لاین وارد شده تا سه رقم می تواند باشد."
                    label="تعداد لاین"
                    maxlength="3"
                    name="number"
                    pattern="[0-9]*"
                    required
                    @keypress="allowOnlyNumbers($event,name,type)"
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-btn :disabled="linesCount <= 0" :loading="loading" class="btn-buy" @click="buySlot(linesCount)">
                <span class="fa fa-shopping-bag ml-2" style="font-size: 1.2rem"></span>
                خرید لاین
              </v-btn>
            </v-col>

          </v-card-text>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import Setting from "@/view/pages/setting";
import Swal from "sweetalert2";
import {Bus} from "@/main";
import Sim from "@/view/sim";
import router from "@/router";

export default {
  name: "addNewNumbers",
  components: {Sim, Setting, TitleRibbon},
  props: {
    list: {
      default: false
    }
  },
  data() {
    return {
      tab: null,
      checkCode: false,
      linesCount: '',
      price: 0,
      expire: 0,
      expired: false,
      reachable: '',
      max: 6,
      addOwnNum: false,
      perLinePrice: '',
      number: '',
      expireTime: '',
      loading: false,
      confirmCode: '',
      numberRules: [
        v => !!v || 'شماره را وارد کنید',
        v => (v.length === 11) || 'شماره را به درستی وارد کنید',
      ],
      alertConfirm: false,
    }
  },
  methods: {
    getConfirmCode() {
      const vm = this;
      if (vm.number.length > 10) {
        this.$modal.error('شماره تماس خودرا بدون 0 وارد کنید.');
        return false;

      } else {
        vm.loading = true;
        $.ajax({
          url: `${url}/phone/authenticate`,
          type: 'POST',
          data: {phone: vm.number},
          fn: this.getConfirmCode,
          headers: {
            'ACCEPT': 'application/json',
            Authorization: Token
          },
          msg: false,
          statusCode: {
            200: function (res) {
              vm.checkCode = true;
              vm.$nextTick(function () {
                vm.$refs.confirmCode.focus();
              })
              vm.loading = false;
            },
            422: function (res) {
              //FIXME: Haji man tarsidam ino dat bezaram
              if (res.responseJSON.errors.phone[0] === 'validation.numeric') {
                vm.checkCode = false;
                vm.confirmCode = '';
                Swal.fire({
                  title: 'خطا',
                  icon: 'error',
                  text: 'شماره وارد شده باید فقط شامل اعداد باشد!',
                  type: 'error',
                  confirmButtonText: 'باشه'
                })
              } else if (res.responseJSON.errors.phone[0] === 'validation.required') {
                vm.checkCode = false;
                vm.confirmCode = '';
                Swal.fire({
                  title: 'خطا',
                  icon: 'error',
                  text: 'شماره را وارد کنید!',
                  type: 'error',
                  confirmButtonText: 'باشه'
                })
              } else if (res.responseJSON.errors.phone[1] === 'validation.min.numeric') {
                vm.checkCode = false;
                vm.confirmCode = '';
                Swal.fire({
                  title: 'خطا',
                  icon: 'error',
                  text: 'شماره را به درستی وارد کنید!',
                  type: 'error',
                  confirmButtonText: 'باشه'
                })
              } else if (res.responseJSON.errors.phone[1] === 'validation.digits') {
                vm.checkCode = false;
                vm.confirmCode = '';
                Swal.fire({
                  title: 'خطا',
                  icon: 'error',
                  text: 'شماره را به درستی وارد کنید!',
                  type: 'error',
                  confirmButtonText: 'باشه'
                })
              }
            }
          }
        });
      }
    },
    submitCode() {
      const vm = this
      $.ajax({
        url: `${url}/phone/verify`,
        type: 'POST',
        fn: this.submitCode,
        data: {
          phone: vm.number,
          code: vm.confirmCode,
        },
        headers: {
          'ACCEPT': 'application/json',
          Authorization: Token
        },
        msg: true,
        statusCode: {
          201: ((res) => {
            vm.loading = false;
            vm.checkCode = false;
            vm.confirmCode = '';
            this.number = '';
            this.getSlut();
            router.replace('/Numbers/numberList');
          }),
          422: (function (res) {
            vm.loading = false;
            vm.checkCode = false;
            vm.confirmCode = '';
          }),
        }
      })
    },
    getSlut() {
      $.ajax({
        url: `${url}/user/profile`,
        type: "GET",
        fn: this.getSlut,
        headers: {
          ACCEPT: "application/json",
          Authorization: Token
        },
        success: (res) => {
          this.reachable = res.data.slot;
        }
      })
    },
    buySlot(slotCount) {
      this.loading = true
      $.ajax({
        url: `${url}/shop/number/slot/${slotCount}`,
        type: 'POST',
        fn: this.buySlot,
        params: [slotCount],
        headers: {
          'ACCEPT': 'application/json',
          Authorization: Token
        },
        success: (data) => {
          this.loading = false
        },
        error: (data) => {
          this.loading = false
        },
        msg: true,
        statusCode: {
          200: (res) => {
            this.reachable = this.linesCount;
            this.linesCount = 0;
            this.number = '';
            this.getSlut()
          },
        }
      });
    },
    allowOnlyNumbers(value, name, type) {
      if (typeof value.key != "") {
        let allowedKeys = [8, 46, 38, 40, 37, 39];
        const keypressed = value.which || value.keyCode;
        if (/[^0-9\s]+/.test(value.key)) {
          if (allowedKeys.every(e => e !== keypressed)) {
            value.preventDefault();
          }
        } else return true
      }
    },
  },
  mounted() {
    this.getSlut();
    Bus.$on('sendSetting', (value) => {
      this.expireTime = value.expire;
      this.perLinePrice = value.price
    });

    this.$route.meta.has_ribbon = !this.list
  }
}
</script>

<style scoped>
.buyBtn {
  transition: 0.5s;
  background-size: 200% auto;
  color: #1c0152;
  border-radius: 5px;
  display: block;
  font-size: 12pt;
  text-align: center;
}

.buyBtn:hover {
  background-image: linear-gradient(to right, #5C258D 0%, #4389A2 51%, #5C258D 100%);
  background-position: right center; /* change the direction of the change here */
  color: #fff;
  text-decoration: none;
  border: none;
}

.fa-plus:hover {
  color: white !important;
}

.rp-spinner:hover .rp_svg {
  animation: rp 4s linear infinite;
  transform: rotate3d(0, 1, 0, 369deg);
}

@keyframes rp {
  from {
    transform: rotate3d(0, 0, 0, 0);
  }

  to {
    transform: rotate3d(0, 1, 0, 360deg)
  }
}
</style>